define('C3.ShoppingExtensions.PDP.MakeAnOffer.View', [
    'c3_shoppingextensions_makeanoffer_view.tpl',
    'Profile.Model',
    //'SC.Configuration',
    'Utils',
    'C3.ShoppingExtensions.PDP.MakeAnOffer.Countries.View',
    'C3.ShoppingExtensions.PDP.MakeAnOffer.States.View',
    'Backbone.View',
    'C3.ShoppingExtensions.PDP.MakeAnOffer.Model',
    'Backbone.FormView',
    'GlobalViews.Message.View',
    'C3.ShoppingExtensions.PDP.MakeAnOffer.CustomerCategory.Model',
    'AjaxRequestsKiller',
], function (
    c3_shoppingextensions_makeanoffer_view_tpl,
    ProfileModel,
    //Configuration,
    Utils,
    CountriesView,
    StatesView,
    BackboneView,
    NXTurnShoppingExtensionsPDPMakeAnOfferModel,
    BackboneFormView,
    GlobalViewsMessageView,
    CustomerCategoryModel,
    AjaxRequestsKiller
) {
    'use strict';
    return Backbone.View.extend({
        template: c3_shoppingextensions_makeanoffer_view_tpl,

        initialize: function (options) {
            this.options = options;
            this.configuration = options.configuration;

            this.layout = options.layout;
            this.item=options.item;

            this.countries = this.configuration.get('siteSettings.countries', []);

            var profile = ProfileModel.getInstance(),
                is_logged_in = profile.get('isLoggedIn') === 'T' && profile.get('isGuest') === 'F';

            if (is_logged_in) {
                var addressBook = profile.get('addressbook');

                var find_shippingAddr = _.findWhere(addressBook, {
                    defaultshipping: 'T',
                });

                if (find_shippingAddr) {
                    this.loggedUserCountry = find_shippingAddr.country;
                    this.loggedUserState = find_shippingAddr.state;
                }
            }

            this.model = new NXTurnShoppingExtensionsPDPMakeAnOfferModel();
            this.model.on('save', _.bind(this.redirect, this));

            var self = this;
            var profile = ProfileModel.getInstance(),
                is_logged_in = profile.get('isLoggedIn') === 'T' && profile.get('isGuest') === 'F';

            if (is_logged_in) {
                var customerid = profile.get('internalid');
                var customerCategory = new CustomerCategoryModel();
                customerCategory
                    .fetch({
                        data: {
                            customerid: customerid,
                        },
                        killerId: AjaxRequestsKiller.getKillerId(),
                    })
                    .done(function (res) {
                        var responseData = res.customercategory;
                        self.customerCategory = responseData;
                        //console.log(responseData)
                        $('#in-modal-ima').val(responseData).change();
                        //self._render();
                    });
            }

            BackboneFormView.add(this);
            //this.page_domain = window.location.origin;
            //this.page_domain= this.page_domain+"/api/items?fieldset=details&q="+this.options.itemid;
            //console.log('initialize')

            this.selectedFunctional = this.getParam('functional') || null;
            this.selectedCosmetic   = this.getParam('cosmetic')   || null;
            this.selectedDisposable = this.getParam('disposable') || null;
        },

      getParam : function getParam(name) {
            const url = new URL(window.location.href);
            let value = url.searchParams.get(name);
            if (!value) {
                const hash = window.location.hash || '';
                if (hash.includes('?')) {
                    const hashParams = new URLSearchParams(hash.split('?')[1]);
                    value = hashParams.get(name);
                }
            }
            return value;
        } ,

        events: {
            'change [data-action="selectcountry"]': 'updateStates',
            'submit form': 'submitForm',
        },

        bindings: {
            '[name="firstname"]': 'firstname',
            '[name="lastname"]': 'lastname',
            '[name="company"]': 'company',
            '[name="phone"]': 'phone',
            '[name="email"]': 'email',
            '[name="language"]': 'language',
            '[name="ima"]': 'ima',
            /*'[name="state"]': 'state',*/
            '[name="country"]': 'country',
            '[name="offeramount"]': 'offeramount',
        },

        /*render: function(){
			

			//this._render();
		},*/

        redirect: function (context, response) {
            var responseData = response.responseData,
                parseResponseData = JSON.parse(responseData),
                responseStatus = parseResponseData.responseStatus,
                message = '',
                type = '';

            //var Layout = SC.Application('Shopping').getComponent('Layout');

            if (parseResponseData) {
                if (responseStatus == 'Success') {
                    message = "You've successfully submitted the request.";
                    type = 'success';
                } else {
                    message = 'An error occured while submitting the request.';
                    type = 'warning';
                }
                //var message = "You've successfully submitted the request."
                var $alert_placeholder = $('.make-an-offer-msg-placeholder');
                var alert = new GlobalViewsMessageView({
                    message: message,
                    type: type,
                    closable: true,
                });
                alert.show($alert_placeholder, 10000);

                //console.log(responseStatus)
            }
        },

        submitForm: function (e, model, props) {
            e.preventDefault();

            var self = this;
            var data = jQuery(e.target).closest('form').serializeObject();
			console.log('Make offer form data', data);

            return this.cancelableTrigger('before:C3.ShoppingExtensions.PDP.MakeAnOffer', data).then(function () {
                self.saveForm(e, model, props);
            });
        },

        childViews: {
            'Countries.View': function () {
                //console.log(this.loggedUserCountry)
                if (this.loggedUserCountry) this.selectedCountry = this.loggedUserCountry;

                return new CountriesView({
                    countries: this.countries,
                    selectedCountry: this.selectedCountry,
                    manage: this.options.manage,
                });
            },
            'States.View': function () {
                //console.log(this.loggedUserState)
                if (this.loggedUserState) this.selectedState = this.loggedUserState;

                if (this.loggedUserCountry) this.selectedCountry = this.loggedUserCountry;

                return new StatesView({
                    countries: this.countries,
                    selectedCountry: this.selectedCountry,
                    selectedState: this.selectedState,
                    manage: this.manage,
                });
            },
        },

        updateStates: function (e) {
            var statesView = this.getChildViewInstance('States.View');
            var selectedCountry = this.$(e.currentTarget).val();

            var self = this;

            var find_country = _.findWhere(self.countries, {
                name: selectedCountry,
            });

            //console.log(this.selectedCountry)

            //this.selectedCountry = '';

            if (find_country) {
                statesView.options.selectedCountry = find_country.code;
                this.selectedCountry = find_country.code;
                statesView.render();
            }
            //console.log(this.selectedCountry)
        },

        getContext: function getContext() {
            var profile = ProfileModel.getInstance(),
                is_logged_in = profile.get('isLoggedIn') == 'T' && profile.get('isGuest') == 'F',
                loggedUserFirstName = '',
                loggedUserLastName = '',
                loggedUserEmail = '',
                //, 	loggedUserCountry = ''
                //,   loggedUserState = ''
                loggedUserCompany = '',
                loggedUserPhone = '',
                self = this;

            if (is_logged_in) {
                loggedUserFirstName = profile.get('firstname');
                loggedUserLastName = profile.get('lastname');
                loggedUserEmail = profile.get('email');
                loggedUserCompany = profile.get('companyname');

                var PhoneInfo = profile.get('phoneinfo');
                loggedUserPhone = PhoneInfo.phone;
            }

            var makeAnOfferConfgn = this.configuration.PDPMakeAnOffer,
                makeAnOfferConfig = makeAnOfferConfgn.config,
                makeAnOfferSalesRepConfgn = this.configuration.PDPMakeAnOfferSalesRep,
                makeAnOfferSalesRepConfig = makeAnOfferSalesRepConfgn.config;

            _.each(makeAnOfferConfig, function (salesrep) {
                if (salesrep.customercategoryid == self.customerCategory) salesrep.isSelected = true;
            });

            var itemImages = this.item.itemimages_detail;
            var imageUrl = '';
            if (itemImages && itemImages.urls && itemImages.urls.length > 0) {
                imageUrl = itemImages.urls[0].url;
            }

            //var selectedFunctional = this.configuration
            var fFunctionalCondition = this.configuration.SerialLotFunctionalConditions
             ,   cCosmeticCondition = this.configuration.SerialLotCosmeticConditions
             ,   dDisposableCondition = this.configuration.SerialLotDisposableConditions
             ,   selected_functional = ''
             ,   selected_cosmetic = ''
             ,   selected_disposable = ''


            

            if(this.selectedFunctional)
            selected_functional = _.findWhere(fFunctionalCondition.config, {
                    id: this.selectedFunctional,
                });

             //console.log(selected_functional)

            if(this.selectedCosmetic)
            selected_cosmetic = _.findWhere(cCosmeticCondition.config, {
                    id: this.selectedCosmetic,
                });

            if(this.selectedDisposable && dDisposableCondition)
            selected_disposable = _.findWhere(dDisposableCondition.config, {
                    id: this.selectedDisposable,
                });

            console.log(cCosmeticCondition)

            return {
                itemsku: this.options.itemid,
                itemname: this.options.itemname,
                imageUrl : imageUrl,
                itemInternalId: this.options.internalid,
                isLoggedIn: is_logged_in,
                loggedUserFirstName: loggedUserFirstName,
                loggedUserLastName: loggedUserLastName,
                loggedUserEmail: loggedUserEmail,
                loggedUserCompany: loggedUserCompany,
                loggedUserPhone: loggedUserPhone,
                makeAnOfferConfig: makeAnOfferConfig,
                makeAnOfferSalesRepConfig: makeAnOfferSalesRepConfig,
                selectedCustomerCategory: this.customerCategory,
                safariBrowserMac: typeof navigator !== 'undefined' && navigator.vendor.indexOf('Apple') > -1 ? true : false,
                selectedFunctionalLabel : selected_functional && selected_functional.label,
                selectedFunctionalId : selected_functional && selected_functional.id,
                selectedCosmeticLabel : selected_cosmetic && selected_cosmetic.label,
                selectedCosmeticId : selected_cosmetic && selected_cosmetic.id,
                selectedDisposableLabel : selected_disposable && selected_disposable.label,
                selectedDisposableId : selected_disposable && selected_disposable.id
            };
        },
    });
});
